import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const TableShimmer = ({ count = 10 }) => {
    const [theme, setTheme] = useState(
        document.documentElement.getAttribute("data-bs-theme") || "light"
    );

    const labels = [
        "Avoid taking more painkillers than prescribed",
        "This medicine helps reduce fever quickly",
        "Take this tablet only after meals",
        "Helps reduce body pain and inflammation",
        "Complete the full antibiotic course",
        "This syrup can ease cough and throat irritation",
        "Avoid mixing this medicine with alcohol",
        "Check dosage before every use",
        "Effective for managing fever and chills",
        "May cause drowsiness. Avoid driving",
        "Keep medicines away from children",
        "Helps regulate blood pressure levels",
        "Used for diabetes management support",
        "Reduces acidity and heartburn",
        "Check for allergies before taking"
    ];

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const newTheme =
                document.documentElement.getAttribute("data-bs-theme") || "light";
            setTheme(newTheme);
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["data-bs-theme"],
        });

        return () => observer.disconnect();
    }, []);

    const shimmerThemeClass =
        theme === "dark" ? "shimmer-dark" : "shimmer-light";

    return (
        <div className="container-fluid p-0 m-0" style={{ overflowX: "hidden" }}>

            {/* Top placeholder shimmer */}
            <div
                className={`mb-3 shimmer ${shimmerThemeClass}`}
                style={{
                    height: "60px",
                    borderRadius: "6px",
                    width: "100%",
                    overflow: "hidden"
                }}
            />

            {/* Rows with placeholder text */}
            <div className="d-flex flex-column gap-2">
                {[...Array(count)].map((_, i) => {
                    const randomText = labels[Math.floor(Math.random() * labels.length)];
                    return (
                        <div
                            key={i}
                            className={`shimmer ${shimmerThemeClass} d-flex align-items-center`}
                            style={{
                                height: "50px",
                                borderRadius: "6px",
                                width: "100%",
                                overflow: "hidden",
                                position: "relative",
                                paddingLeft: "16px"
                            }}
                        >
                            <span
                                style={{
                                    opacity: 0.2,
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    color: theme === "dark" ? "#fff" : "#000",
                                    userSelect: "none"
                                }}
                            >
                                {randomText}
                            </span>
                        </div>
                    );
                })}
            </div>

            <style>
                {`
          .shimmer {
            animation: shimmerMove 1.5s infinite linear;
            background-size: 200% 100%;
            position: relative;
          }

          .shimmer-light {
            background-image: linear-gradient(
              to right,
              #e2e2e2 0%,
              #f0f0f0 50%,
              #e2e2e2 100%
            );
          }

          .shimmer-dark {
            background-image: linear-gradient(
              to right,
              #2d2d2d 0%,
              #444444 50%,
              #2d2d2d 100%
            );
          }

          @keyframes shimmerMove {
            0% { background-position: 200% 0; }
            100% { background-position: -200% 0; }
          }
        `}
            </style>
        </div>
    );
};

export default TableShimmer;
